/** Valores que a base usa como "não sei" — exibi-los seria pior que omitir. */
const PLACEHOLDERS = new Set([
  'INDEFINIDO',
  'DIVERSOS',
  'NAO INFORMADO',
  'NÃO INFORMADO',
  'N/A',
  '-',
  '--',
]);

/**
 * String exibível, ou `null`.
 *
 * Mesma regra que `LotItemCard` aplica na listagem peça a peça: a busca mostra
 * as mesmas peças do mesmo estoque, e uma linha de resultado escrita
 * "INDEFINIDO" enquanto a linha do lote omite o campo seria a mesma peça com
 * duas caras.
 */
export function meaningful(value: string | null | undefined): string | null {
  const v = (value ?? '').trim();
  if (!v || PLACEHOLDERS.has(v.toUpperCase())) return null;
  return v;
}
